module.exports = __webpack_public_path__ + "static/stewardship_forest-f76f568bf0cc3bcb6ea57753bc4dd9a9.jpg";